import { DocumentModel } from "./DocumentModel";
export class CreateAssetCollectionRequest {
  constructor(
    public title: string,
    public referenceNumber: string,
    public documents: DocumentModel[]
  ) {}
}
